import { useAccount } from 'frontastic';

const useTradeAccount = () => {
  const { account, isResolved } = useAccount();

  return { isTradeAccount: !!account?.isTradeAccount, isResolved };
};

export default useTradeAccount;
